import type { FieldRendererProps } from '../../config/types';
import { Input } from '@/components/ui/Input';

export function TextFieldRenderer({ field, value, onChange, onBlur, error }: FieldRendererProps) {
  const maxLength = field.resolvedValidations.maxLength;
  // `props.inputMode` picks the on-screen keyboard only; the field stays free text (a number typed
  // here is sent as typed, and the server judges it). ENT-565: a whole-number or decimal input that
  // must not refuse a stray letter before the server can name the problem.
  const inputMode = field.props?.inputMode;
  return (
    <Input
      type="text"
      id={field.id}
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={field.placeholder}
      disabled={field.isDisabled}
      maxLength={maxLength}
      inputMode={inputMode === 'numeric' || inputMode === 'decimal' || inputMode === 'tel' || inputMode === 'email' ? inputMode : undefined}
      aria-invalid={!!error}
      aria-describedby={error ? `${field.id}-issues` : undefined}
    />
  );
}
